if (!customElements.get('about-content-slider')) {
  customElements.define(
    'about-content-slider',
    class AboutContentSlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if (!this.sliderEl) return;

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1.15,
          spaceBetween: 16,
          breakpoints: {
            1024: {
              slidesPerView: 'auto',
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: '.about-content-slider-button.prev',
            nextEl: '.about-content-slider-button.next'
          },
          pagination: {
            el: '.about-content-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}
